import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import moment from 'moment';
import { LoginTrendAnalysisService } from 'src/app/services/login-trend-analysis.service';
import {
    ApexAxisChartSeries,
    ApexChart,
    ApexXAxis,
    ApexTitleSubtitle,
    ApexTooltip,
    ApexDataLabels,
    ApexStroke,
    ApexFill,
    ApexMarkers,
    ApexYAxis,
    ApexLegend,
} from 'ng-apexcharts';

@Component({
    selector: 'app-login-trend-analysis',
    templateUrl: './login-trend-analysis.component.html',
    styleUrls: ['./login-trend-analysis.component.scss']
})
export class LoginTrendAnalysisComponent implements OnInit {
    serviceQueue: any = [];
    monthlyWebActivity: any;
    monthlyMobileActivity: any;
    monthlyCoverageActivity: any;
    monthlywebusagelabels: any;
    updatedTime: any;
    monthlywebusagedata: any[];
    mobileactivitylabels: any;
    mobileactivitydata: any[];
    coverageactivitylabels: any;
    coverageactivitydata: any[];
    totalVisitor: any = "0";
    newVisitor: any = "0";
    totalCoverage = "0";
    availableCoverage = "0";
    day = moment().format('DD');
    parsedDay: any
    chartcolors = [
        '#00AFFF', // blue
        '#DCDCDC', // light grey
    ];
    coverageactivityseries: string[];
    isMobileShow: boolean = false
    webActivity: boolean;
    mobileActivity: boolean;

    Month = moment().format('MMM YYYY');
    CoverageMonth = moment().format('MMM YYYY');

    CurrrentMonth = moment().format('MMM');
    LastMonth = moment().subtract(1, 'months').format('MMM');
    LastBeforeMonth = moment().subtract(2, 'months').format('MMM')

    CurrrentCoverageMonth = moment().format('MMM');
    LastCoverageMonth = moment().subtract(1, 'months').format('MMM');
    LastBeforeCoverageMonth = moment().subtract(2, 'months').format('MMM')

    dropdownOpen = false;

    public chartOptions: any
    public coverageChartOptions: any
    public chartSeries: ApexAxisChartSeries
    public coverageChartSeries: ApexAxisChartSeries
    loginActivityTitle = ['Total Visitors', 'New Visitors']
    CovergaeActivityTitle = ["Total Coverage", "Coverage Available"];
    @ViewChild('scrolltoBottom') scrolltoBottom: ElementRef
    constructor(private loginTrendAnalysisService: LoginTrendAnalysisService, private eRef: ElementRef) {
        this.parsedDay = parseInt(this.day.replace(/^0+/, ''), 10);
    }

    ngOnInit() {
        this.getCurrentMonthLoginActivity()
        this.getCurrentMonthMobileLoginActivity()
        this.getCurrentMonthCoverageActivity()
    }

    toggleDropdown() {
        this.dropdownOpen = !this.dropdownOpen;
    }

    getCurrentMonthLoginActivity() {
        debugger
        this.loginTrendAnalysisService.getCurrentMonthLoginActivity().subscribe(res => {
            debugger
            this.monthlyWebActivity = res;
            this.updatedTime = this.monthlyWebActivity[this.monthlyWebActivity.length - 1];
            this.monthlywebusagelabels = this.monthlyWebActivity.map(x =>
                moment(x.date).format('DD/MM/YYYY')
            );
            this.monthlywebusagedata = [
                this.monthlyWebActivity.map(x => x.totalVisitor),
                this.monthlyWebActivity.map(x => x.newVisitor)
            ];
            // if (this.monthlywebusagedata) {
            //     this.totalVisitor = this.monthlywebusagedata[0][this.parsedDay - 1];
            //     this.newVisitor = this.monthlywebusagedata[1][this.parsedDay - 1];
            // }
            if (this.monthlywebusagedata && this.monthlywebusagedata[0].length > 0) {
                // Fix: Use the last available data point instead of the current day
                const lastIndex = this.monthlywebusagedata[0].length - 1;
                this.totalVisitor = this.monthlywebusagedata[0][lastIndex];
                this.newVisitor = this.monthlywebusagedata[1][lastIndex];
            }

            this.chartRefresh(this.monthlywebusagedata, this.monthlywebusagelabels, this.loginActivityTitle, `Login Web Activity for ${this.Month}`)
        })
    }


    getCurrentMonthMobileLoginActivity() {
        this.loginTrendAnalysisService.getCurrentMonthMobileLoginActivity().subscribe(res => {
            this.monthlyMobileActivity = res;
            this.mobileactivitylabels = this.monthlyMobileActivity.map(x =>
                moment(x.date).format('DD/MM/YYYY')
            );
            this.mobileactivitydata = [
                this.monthlyMobileActivity.map(x => x.totalVisitor),
                this.monthlyMobileActivity.map(x => x.newVisitor)
            ];

        })
    }
    getCurrentMonthCoverageActivity() {
        this.loginTrendAnalysisService.getCurrentMonthCoverageActivity().subscribe(res => {
            this.monthlyCoverageActivity = res;
            this.coverageactivitylabels = this.monthlyCoverageActivity.map(x =>
                moment(x.date).format('DD/MM/YYYY')
            );
            this.coverageactivitydata = [
                this.monthlyCoverageActivity.map(x => x.totalCoverage),
                this.monthlyCoverageActivity.map(x => x.coverageAvailable)
            ];
            // if (this.coverageactivitydata) {
            //     this.totalCoverage = this.coverageactivitydata[0][this.parsedDay - 1];
            //     this.availableCoverage = this.coverageactivitydata[1][this.parsedDay - 1];
            // }
            // this.chartRefresh2(this.coverageactivitydata, this.coverageactivitylabels, this.CovergaeActivityTitle,  `Coverage Activity for ${this.CoverageMonth}`)
            if (this.coverageactivitydata && this.coverageactivitydata[0].length > 0) {
                const lastIndex = this.coverageactivitydata[0].length - 1;
                this.totalCoverage = this.coverageactivitydata[0][lastIndex];
                this.availableCoverage = this.coverageactivitydata[1][lastIndex];
            }
            this.chartRefresh2(this.coverageactivitydata, this.coverageactivitylabels, this.CovergaeActivityTitle, `Coverage Activity for ${this.CoverageMonth}`)


        })
    }

    loginTrendActivity() {
        debugger
        this.isMobileShow = !this.isMobileShow
        if (this.isMobileShow) {
            this.chartRefresh(this.mobileactivitydata, this.mobileactivitylabels, this.loginActivityTitle, `Login Mobile Activity for ${this.Month}`)
        }
        else {
            this.chartRefresh(this.monthlywebusagedata, this.monthlywebusagelabels, this.loginActivityTitle, `Login Web Activity for ${this.Month}`)
        }

    }

    selectMonth(option) {
        debugger
        const months = [this.CurrrentMonth, this.LastMonth, this.LastBeforeMonth];
        this.Month = months[option];
        this.dropdownOpen = false;
        if (option == 0) {
            this.Month = moment().format('MMM YYYY')
        }
        else {
            this.Month = moment().subtract(option, 'months').date(1).format('MMM YYYY')
        }
        this.loadSelectedMonthChart(option)
    }
    selectMonthCoverage(option) {
        const months = [this.CurrrentMonth, this.LastMonth, this.LastBeforeMonth];
        this.CoverageMonth = months[option];
        this.dropdownOpen = false;

        if (option == 0) {
            this.CoverageMonth = moment().format('MMM YYYY')
        }
        else {
            this.CoverageMonth = moment().subtract(option, 'months').date(1).format('MMM YYYY')
        }
        this.scrolltoBottom?.nativeElement?.scrollIntoView({ behavior: 'smooth' });
        this.loadSelectedCoverageChart(option)
    }
    loadSelectedMonthChart(option: string): void {
        debugger
        this.loginTrendAnalysisService.getSelectedMonthLoginActivity(option).subscribe(results => {
            debugger
            if (results) {
                debugger
                this.monthlyWebActivity = results;

                //***** Web Login Activity ******
                this.monthlywebusagelabels = this.monthlyWebActivity.map(x =>
                    moment(x.date).format('DD/MM/YYYY')
                );
                this.monthlywebusagedata = [
                    this.monthlyWebActivity.map(x => x.webTotalVisitor),
                    this.monthlyWebActivity.map(x => x.webNewVisitor)
                ];
                this.mobileactivitydata = [
                    this.monthlyWebActivity.map(x => x.mobileTotalVisitor),
                    this.monthlyWebActivity.map(x => x.mobileNewVisitor)
                ];
                if (this.isMobileShow) {
                    this.chartRefresh(this.mobileactivitydata, this.monthlywebusagelabels, this.loginActivityTitle, `Login Mobile Activity for ${this.Month}`)
                }
                else {
                    this.chartRefresh(this.monthlywebusagedata, this.monthlywebusagelabels, this.loginActivityTitle, `Login Web Activity for ${this.Month}`)
                }
            }
        });
    }
    loadSelectedCoverageChart(option: string): void {
        this.loginTrendAnalysisService.getSelectedMonthCoverageActivity(option).subscribe(results => {
            if (results) {
                this.monthlyCoverageActivity = results;

                //***** Coverage Activity ******
                this.coverageactivitylabels = this.monthlyCoverageActivity.map(x =>
                    moment(x.date).format('DD/MM/YYYY')
                );

                this.coverageactivitydata = [
                    this.monthlyCoverageActivity.map(x => x.totalCoverage),
                    this.monthlyCoverageActivity.map(x => x.coverageAvailable)
                ];
                this.chartRefresh2(this.coverageactivitydata, this.coverageactivitylabels, this.CovergaeActivityTitle, `Coverage Activity for ${this.CoverageMonth}`)
            }
        });
    }
    // Listen for clicks outside the dropdown to close it
    @HostListener('document:click', ['$event'])
    onClickOutside(event: Event) {
        if (!this.eRef.nativeElement.contains(event.target)) {
            this.dropdownOpen = false;
        }
    }
    chartRefresh(data, lables, title, subtitle) {
        debugger
        this.chartSeries = [
            {
                name: title[0],
                data: data[0] // Example data for visitors
            },
            {
                name: title[1],
                data: data[1] // Example data for new visitors
            }
        ];
        this.chartOptions = {
            chart: {
                type: 'area',
                width: '1000px',
                height: 500, // Keep height the same
                toolbar: {
                    show: false,
                },
            },
            xaxis: {
                categories: lables,
                labels: {
                    style: {
                        fontSize: '14px'
                    },
                    rotate: 0,
                }
            },
            title: {
                text: subtitle,
                align: 'center',
                style: {
                    fontSize: '22px', // Increase title font size
                    fontWeight: 'bold'
                }
            },
            tooltip: {
                shared: true,
                intersect: false,
                y: {
                    formatter: function (val: number) {
                        return val.toString(); // Customize this for formatting if needed
                    },
                },
            },
            stroke: {
                curve: 'smooth',
                width: 2 // Thicker line
            },
            fill: {
                type: 'gradient',
                gradient: {
                    shadeIntensity: 1,
                    opacityFrom: 0.7,
                    opacityTo: 0.9,
                    stops: [0, 90, 100],
                },
            },
            dataLabels: {
                enabled: false,
            },
            markers: {
                size: 6, // Bigger marker size
            },
            yaxis: {
                labels: {
                    style: {
                        fontSize: '14px' // Larger y-axis label font size
                    },
                    formatter: function (val: number) {
                        return val.toFixed(0); // Format the y-axis values
                    }
                },
                title: {
                    text: 'Visitors',
                    style: {
                        fontSize: '16px' // Larger y-axis title font size
                    }
                }
            },
            legend: {
                position: 'top',
                horizontalAlign: 'center',
                fontSize: '16px', // Larger legend font size
            }
        };
    }
    chartRefresh2(data, lables, title, subtitle) {


        debugger
        this.coverageChartSeries = [
            {
                name: title[0],
                data: data[0] // Example data for visitors
            },
            {
                name: title[1],
                data: data[1] // Example data for new visitors
            }
        ];
        this.coverageChartOptions = {
            chart: {
                type: 'area',
                width: '1000px',
                height: 500, // Keep height the same
                toolbar: {
                    show: false,
                },
            },
            xaxis: {
                categories: lables,
                labels: {
                    style: {
                        fontSize: '14px'
                    },
                    rotate: 0,
                }
            },
            title: {
                text: subtitle,
                align: 'center',
                style: {
                    fontSize: '22px', // Increase title font size
                    fontWeight: 'bold'
                }
            },
            tooltip: {
                shared: true,
                intersect: false,
                y: {
                    formatter: function (val: number) {
                        return val.toString(); // Customize this for formatting if needed
                    },
                },
            },
            stroke: {
                curve: 'smooth',
                width: 2 // Thicker line
            },
            fill: {
                type: 'gradient',
                gradient: {
                    shadeIntensity: 1,
                    opacityFrom: 0.7,
                    opacityTo: 0.9,
                    stops: [0, 90, 100],
                },
            },
            dataLabels: {
                enabled: false,
            },
            markers: {
                size: 6, // Bigger marker size
            },
            yaxis: {
                labels: {
                    style: {
                        fontSize: '14px' // Larger y-axis label font size
                    },
                    formatter: function (val: number) {
                        return val.toFixed(0); // Format the y-axis values
                    }
                },
                title: {
                    text: 'Coverages',
                    style: {
                        fontSize: '16px' // Larger y-axis title font size
                    }
                }
            },
            legend: {
                position: 'top',
                horizontalAlign: 'center',
                fontSize: '16px', // Larger legend font size
            }
        };

    }




}

